import { useState } from "react";
import { Redirect } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
// Redux
import { useSelector } from "react-redux";
// Constants
import { WEB_SERVICE_MIMS, pathHomePage } from "../../../../config/constants";
// Components
import Axios from "../../../../config/axios";
import { DeletePatientDiv, DeleteText, BackAndDeleteDiv, BackButton, DeleteButton } from "./styles";

const DeletePatient = ({ setIsShowDeletePatient, patientId, patientVersion }) => {
  const [redirectToPatientsList, setRedirectToPatientsList] = useState(false);
  const [redirectToDeletedPatient, setRedirectToDeletedPatient] = useState(false);

  const clinicianToken = useSelector(({ clinician }) => clinician.data.token);
  const patientIdFromOrionWeb = useSelector(({ clinician }) => clinician.data.PATIENT_ID);
  const [t] = useTranslation("global");

  const handleSetShowDeletePatient = (e) => {
    e.preventDefault();
    setIsShowDeletePatient(false);
  };
  const handleDeletePatient = (e) => {
    e.preventDefault();
    const URL = `${WEB_SERVICE_MIMS}/patients/delete/${patientId}/${patientVersion}`;
    Axios("put", URL)
      .then(({ data }) => {
        if (data.deletedPatient) {
          toast.success(t("deletePatient_deletedPatientMessage"));
          if (patientIdFromOrionWeb) {
            setRedirectToDeletedPatient(true);
          } else {
            setRedirectToPatientsList(true);
          }
        } else {
          toast.error(t("sendDataErrorMessage"));
        }
      })
      .catch((error) => {
        toast.error(t("sendDataErrorMessage"));
        console.log("url error: ", error);
      });
  };
  if (redirectToPatientsList) {
    return <Redirect to={`${pathHomePage}/home/${clinicianToken}`} />;
  }
  if (redirectToDeletedPatient) {
    return <Redirect to={`${pathHomePage}/deleted-patient/${clinicianToken}`} />;
  }

  return (
    <DeletePatientDiv>
      <DeleteText>{t("deletePatient_deletePatientText")}</DeleteText>
      <BackAndDeleteDiv>
        <BackButton onClick={handleSetShowDeletePatient}>{t("back")}</BackButton>
        <DeleteButton onClick={handleDeletePatient}>{t("delete")}</DeleteButton>
      </BackAndDeleteDiv>
    </DeletePatientDiv>
  );
};

export default DeletePatient;
